import React from 'react';
import PropTypes from 'prop-types';
import currencyFormat from 'utils/currency-format';
function Exchange({ price, currency, decimals })
{
    const usdPrice = currencyFormat(price, 2);
    return (
        <>
            {currency !== null && currency.code !== 'USD'
                && `${usdPrice}[${currencyFormat(price * currency.currency_change, decimals, currency.code)} ] `
                    + `Rate: ${currency.currency_change}`}

            {(currency === null || currency.code === 'USD')
                && `${usdPrice}`}
        </>
    );
}

Exchange.propTypes = {
    price: PropTypes.any.isRequired,
    decimals: PropTypes.number,
    currency: PropTypes.shape(
        {
            currency_change: PropTypes.number,
            code: PropTypes.string,
        },
    ),
};

Exchange.defaultProps = {
    decimals: 2,
};
export default Exchange;
